import { BasisPointsInput, type BasisPointsInputProps } from '@klear/ui/components/basis-points-input'
import type { BasisPoints } from '@klear/basis-points'
import { useFormContext } from 'react-hook-form'
import get from 'lodash/get'
import noop from 'lodash/noop'

interface FormBasisPointsInputProps extends Omit<BasisPointsInputProps, 'value' | 'onChange' | 'errorMessage'> {
  name: string
  onValueChange?: (value: BasisPoints | undefined) => void
}

const FormBasisPointsInput = ({ name, onBlur = noop, onValueChange, ...rest }: FormBasisPointsInputProps) => {
  const {
    formState: { errors },
    watch,
    setValue
  } = useFormContext()

  const currentValue = watch(name) as BasisPoints | undefined
  const fieldError = get(errors, name)
  const errorMessage = get(fieldError, 'message')

  const handleChange = (value: BasisPoints | undefined) => {
    setValue(name, value, { shouldValidate: true })
    onValueChange?.(value)
  }

  return (
    <BasisPointsInput
      {...rest}
      value={currentValue}
      onChange={handleChange}
      onBlur={onBlur}
      errorMessage={errorMessage?.toString()}
    />
  )
}

export default FormBasisPointsInput
